<template>
    <b-modal
        v-model="isVisible"
        modal-class="scopes-update-wrapper vue-need-bootstrap"
        title="Update your Etsy store"
        lazy
        centered
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        @close="onSkipHandler"
    >
        <div class="content text-center">
            <p>Due to recent changes in your Etsy account, you need to reconnect your store.</p>
            <template v-for="(session, index) of sessions">
                <etsy-store-needs-reconnection-modal-item v-if="session.shop" :key="index" :shop="session.shop" />
            </template>

            <a class="skip-link" href="#" @click="onSkipHandler">Skip for now</a>

            <p class="legend">
                If you do not reconnect, Customily won't work properly on your Etsy store, and emails for
                personalization will not be sent.
            </p>
        </div>
    </b-modal>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EtsyStoreNeedsReconnectionModalItem from './item/EtsyStoreNeedsReconnectionModalItem.vue';

@Component({
    name: 'EtsyStoreNeedsReconnectionModal',
    components: { EtsyStoreNeedsReconnectionModalItem }
})
export default class EtsyStoreNeedsReconnectionModal extends Vue {
    @Prop({ default: [], required: false }) sessions!: {
        shop: string;
    }[];

    isVisible = true;

    onSkipHandler() {
        this.$emit('close');
    }
}
</script>

<style scoped lang="scss">
::v-deep .scopes-update-wrapper {
    .modal-header {
        text-align: center;
        background: linear-gradient(141deg, #849dd8 15%, #8bc4d3 75%);
        color: #fff;
    }
    .skip-link {
        color: unset;
        text-decoration: underline;
        font-weight: bold;
    }
    .legend {
        font-size: 12px;
        margin-top: 1rem;
        margin-bottom: 0;
    }
}
</style>
